module.exports = __webpack_public_path__ + "static/img/hos-hk-india-img-ctb01-02-02.7fbf5b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos-hk/hos-hk-india-img-ctb01-02-02.png
// module id = d91u
// module chunks = 0